module.exports = __webpack_public_path__ + "img/206.6fb4fbaa.jpg";